import React, {Component} from 'react';
import './App.css';

import {Route, Switch} from "react-router-dom"
import {library} from '@fortawesome/fontawesome-svg-core'
import {
	faArrowLeft,
	faArrowRight,
	faCheck,
	faCloud,
	faCog,
	faCompressArrowsAlt,
	faExpandArrowsAlt,
	faExternalLinkAlt,
	faLink,
	faMinus,
	faPause,
	faPlay,
	faPlus,
	faTimes,
	faVideo
} from '@fortawesome/free-solid-svg-icons'

import {faFacebookF, faInstagram, faLinkedinIn, faMediumM, faTwitter} from '@fortawesome/free-brands-svg-icons'

import GistPlayer from './screens/Player'
import {Media} from './screens/Media'
import {OrderGistUrl} from './screens/OrderGistUrl'
import {SignIn} from './screens/SignIn'
import Payment from './screens/Payment'
import Registration from './screens/signup/Registration'

import {connect} from 'react-redux';
import {__isAvailable, history, notificationHelper} from './_helpers';
import {alertActions, historyInfoActions} from './_actions';

import styled from '@emotion/styled';
import {PrivateRoute} from "./_components";
import {withTranslation} from "react-i18next";
import {withToastManager} from "react-toast-notifications";
import {PasswordGenerate} from "./screens/PasswordGenerate";
import {PasswordReset} from "./screens/PasswordReset";
import {PasswordChange} from "./screens/PasswordChange";
import {AccountSettings} from "./screens/AccountSettings";
import {CancelAccount} from "./screens/CancelAccount";
import {ZoomConnect} from "./screens/ZoomConnect";
import {ZoomIntegrationHome} from "./screens/ZoomIntegrationHome";
import {Order} from "./screens/Order";
import {OrderConfirmation} from "./screens/OrderConfirmation";
import Redirect from "./components/Redirect";
import {OrderGistZoom} from "./screens/OrderGistZoom";
import {Legal} from "./screens/Legal";
import {OrderGistUpload} from "./screens/OrderGistUpload";
import {Welcome} from "./screens/Welcome";
import {GetLandingPage} from "./screens/GetLanding";
import Embed from "./screens/Embed";
import {Examples} from "./screens/Examples";
import {SwitchSubscription} from "./screens/SwitchSubscription";

library.add(
	faPlay, faPause, faCloud, faTimes, faPlus, faMinus, faCog, faArrowRight, faArrowLeft,
	faExpandArrowsAlt, faCompressArrowsAlt, faVideo, faExternalLinkAlt, faLink, faCheck,
	faMediumM, faFacebookF, faInstagram, faTwitter, faLinkedinIn
);

// STYLE ##########################################################

const MainContainer = styled('div')`
`;

// COMPONENT ##########################################################

class App extends Component {

  componentDidMount() {
	  this.onLoad();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.manageGlobalAlerts(prevProps);
  }

	onLoad() {
		this.manageHistory();
	}

	manageHistory() {
		if ( __isAvailable(window) ) {  // available for client only, not ssr
			this.props.pushHistory(history.location);   // add initial history
			this.invokeHistoryListener();               // invoke-history-listener
		}
	}

	invokeHistoryListener() {
  	    // on location/history changes
		history.listen((location, action) => {
			if(action === "PUSH") {
				this.props.pushHistory(location); // push history
			} else if(action === "POP") {
				this.props.popHistory(location);  // pop history
			}
			this.props.clearAlert();            // clear alert on location change
		});
	}

	manageGlobalAlerts(prevProps) {
		const {alert} = this.props;
		if (alert !== prevProps.alert && alert.message) {
			const {toastManager, t, clearAlert} = this.props;
			const notifierParams = {toastManager, t, clearAlert};
			notificationHelper.handleAlert(alert, notifierParams);  // global notification helper
		}
	}

  render() {
    return (
        <MainContainer>
          <Switch>
            <PrivateRoute exact path="/account"         component={AccountSettings} />
            <PrivateRoute exact path="/cancel"          component={CancelAccount}   />
            <Route              path="/embed/:uuid"     component={Embed}           />
            <Route              path="/get"             component={GetLandingPage}  />
            <Route              path="/examples"        component={Examples}  />
            <Route              path="/debate"          component={GetLandingPage}  />{ /* Support for old route */ }
            <Route              path="/play/:uuid"      component={GistPlayer}      />
            <Route              path="/legal"           component={Legal}           />
            <PrivateRoute exact path="/welcome"         component={Welcome}         />
            <PrivateRoute exact path="/media"           component={Media}           />
            <PrivateRoute exact path="/order"           component={Order}           />
            <PrivateRoute exact path="/order/url"       component={OrderGistUrl}    />
            <PrivateRoute       path="/order/confirm"   component={OrderConfirmation} />
            <PrivateRoute  		  path="/order/zoom"      component={OrderGistZoom} 	/>
            <PrivateRoute       path="/order/upload"	  component={OrderGistUpload}	/>
            <Route              path="/signin"          component={SignIn}          />
            <Route        exact path="/signup"          component={Registration}    />
            <Route              path="/password/forgot" component={PasswordGenerate}/>
            <Route              path="/password/reset"  component={PasswordReset}   />
            <PrivateRoute       path="/payment"         component={Payment}         />
            <PrivateRoute       path="/password/change" component={PasswordChange}  />
            <PrivateRoute       path="/subscribe"       component={SwitchSubscription} />
            <PrivateRoute       path="/zoom/connect"    component={ZoomConnect}     />
            <Route              path="/zoom"            component={ZoomIntegrationHome} />
            <Route              path="/support"         render={(props) => <Redirect loc="https://gistify.zendesk.com" title="Support" {...props}/>} />
            <Route component={GetLandingPage} />
          </Switch>
        </MainContainer>

    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  return {
      alert
  };
}

function mapDispatchToProps(dispatch) {
	return {
		pushHistory : (location)  => dispatch(historyInfoActions.push(location)),
		popHistory  : (location)  => dispatch(historyInfoActions.pop(location)),
		clearAlert  : ()          => dispatch(alertActions.clear()),
	}
}

const connectedApp = withTranslation() (connect(mapStateToProps, mapDispatchToProps)(withToastManager(App)));
export { connectedApp as App };
